import { render, staticRenderFns } from "./uploadsb.vue?vue&type=template&id=68d4ecd2&scoped=true"
import script from "./uploadsb.vue?vue&type=script&lang=js"
export * from "./uploadsb.vue?vue&type=script&lang=js"
import style0 from "./uploadsb.vue?vue&type=style&index=0&id=68d4ecd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d4ecd2",
  null
  
)

export default component.exports